<template>
  <div class="draw">
    <div class="header"></div>
    <div class="turning">
      <div class="turning-table">
        <LuckyWheel
          ref="turningTableRef"
          width="6.26rem"
          height="6.26rem"
          :prizes="prizes"
          @end="endCallback"
        />
      </div>
      <div class="turning-btn" @click="startCallback" />
    </div>
    <div class="content">
      <div class="content-item">
        <div class="content-item__title">活动时间</div>
        <div class="content-item__text">2022年4月1日-2022年6月30日</div>
      </div>
      <div class="content-item">
        <div class="content-item__title">抽奖时间</div>
        <div class="content-item__text">
          达标次月15日以后，抽奖时限为1个月，逾期作废。
        </div>
      </div>
      <div class="content-item">
        <div class="content-item__title">活动内容</div>
        <div class="content-item__text">
          华夏银行深圳分行指定零售贷款客户，金融资产月日均2万以上，可获得一次抽奖机会，每人每月限参与一次。
        </div>
      </div>
    </div>
    <van-dialog
      alert
      v-model:show="isDrawedPopupVisble"
      confirmButtonText="去领取"
      theme="round-button"
      @confirm="onConfirmExchange"
    >
      <div class="drawed-popup">
        <img class="popup__head" src="../../assets/draw-popup-head.png" />
        <img
          class="popup__img"
          :src="`${imgPrefix}${drawedPrize.thumbnailUrl}`"
        />
        <div class="popup__title">{{ drawedPrize.name }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { reactive, toRef, ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Toast } from 'vant'
import globalVariables from '@/utils/globalVariables'
import api from '@/api'

export default {
  setup() {
    const turningTableRef = ref(null)
    const router = useRouter()
    const route = useRoute()
    const { activityCode } = route.query
    let isTurining = false

    const turningItemBackEnum = ['#f6ead1', '#edd9ab', '#ebcd89']
    const data = reactive({
      prizes: [],
      drawedPrize: {
        productId: '',
        name: '',
        thumbnailUrl: ''
      },
      isDrawedPopupVisble: false
    })
    let drawedOrderCode = ''

    // 点击抽奖按钮会触发star回调
    const startCallback = () => {
      if(isTurining) {
        return
      }
      isTurining = true

      // 调用抽奖组件的play方法开始游戏
      turningTableRef.value.play()
      // 模拟调用接口异步抽奖

      api
        .place({
          activityCode,
          activityGiftId: null
        })
        .then(res => {
          if (res.error) {
            Toast.fail(res.error.message)
            turningTableRef.value.stop(-1)
            return
          }
          drawedOrderCode = res.data.orderCode
          data.drawedPrize = data.prizes.find(
            n => n.productId === res.data.productId
          )

          setTimeout(() => {
            const index = data.prizes.findIndex(
              n => n.productId === data.drawedPrize.productId
            )
            // 调用stop停止旋转并传递中奖索引
            turningTableRef.value.stop(index)
         
          }, 3000)
        })
        .catch(err => {
          console.log(err)
          isTurining = false
        })
    }
    // 抽奖结束会触发end回调
    const endCallback = prize => {
      isTurining = false
      if (prize.productId !== data.drawedPrize.productId) return

      data.isDrawedPopupVisble = true
    }

    const onConfirmExchange = () => {
      router.push({
        path: '/orderDetail',
        query: {
          orderCode: drawedOrderCode
        }
      })
    }

    onMounted(() => {
      api
        .getProductList({
          activityCode
        })
        .then(res => {
          data.prizes = res.data.map((item, index) => {
            return {
              fonts: item.name.split('&').map((n,nameIndex) => {
               return   {
                  text: n,
                  top: `${(nameIndex + 1 ) * 10}%`,
                  fontColor: '#dc8a49',
                  fontSize: '0.26rem',
                  fontWeight: '700'
               }
              }),
              imgs: [
                {
                  src: `${globalVariables.imgPrefix}${item.thumbnailUrl}`,
                  width: '30%',
                  top: '35%'
                }
              ],
              background: turningItemBackEnum[index % 3],
              productId: item.id,
              activityGiftId: item.activityGiftId,
              name: item.name,
              thumbnailUrl: item.thumbnailUrl
            }
          })
        })
    })

    return {
      turningTableRef,
      prizes: toRef(data, 'prizes'),
      isDrawedPopupVisble: toRef(data, 'isDrawedPopupVisble'),
      drawedPrize: toRef(data, 'drawedPrize'),
      imgPrefix: globalVariables.imgPrefix,
      startCallback,
      endCallback,
      onConfirmExchange
    }
  }
}
</script>

<style lang="less" scoped>
.draw {
  min-height: 100vh;
  background-image: url('../../assets/draw-title.png'),
    url('../../assets/draw-coin1.png'), url('../../assets/draw-coin2.png'),
    url('../../assets/draw-coin3.png'), url('../../assets/draw-line1.png'),
    url('../../assets/draw-line2.png');
  background-repeat: no-repeat;
  background-size: 161px 24px, 69px 50px, 40px 30px, 42px 34px, 92px 144px,
    106px 183px;
  background-position: 18px 13px, 248px -25px, 356px 87px, -20px 142px,
    -40px 194px, 325px 216px;
  background-color: #a83630;
  overflow: hidden;
  .header {
    width: 262px;
    height: 120px;
    background-image: url('../../assets/draw-head-title.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 68px;
    margin-left: 76px;
  }
  .turning {
    width: 333px;
    height: 409px;
    background-image: url('../../assets/draw-turning-base.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: -26px;
    margin-left: 42px;
    position: relative;
    .turning-table {
      position: absolute;
      top: 25px;
      left: 29px;
      width: 237px;
      height: 237px;
    }
    .turning-btn {
      position: absolute;
      top: 101px;
      left: 115px;
      width: 65px;
      height: 79px;
      background-image: url('../../assets/draw-turning-btn.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .turning-btn:active {
      opacity: 0.8;
    }
  }
  .content {
    margin: -48px 0 0 23px;
    padding-bottom: 20px;
    position: relative;
    .content-item {
      margin-top: 2px;
      .content-item__title {
        display: inline-block;
        font-size: 14px;
        line-height: 12px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #efefef;

        background: #900d0c;
        padding: 4px 5px;
      }
      .content-item__text {
        font-size: 12px;
        line-height: 16px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #efefef;
        margin-top: 7px;
      }
    }
  }
  .drawed-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 14px;
    background-image: url('../../assets/draw-popup-left.png'),
      url('../../assets/draw-popup-right.png');
    background-repeat: no-repeat;
    background-size: 84px 104px, 84px 104px;
    background-position: 10px 14px, 225px 14px;

    .popup__head {
      width: 210px;
      height: 64px;
      margin-top: -35px;
    }
    .popup__img {
      width: 100px;
      height: 95px;
      margin-top: 13px;
    }
    .popup__title {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      margin-top: 16px;
    }
  }
}
</style>

<style>
.draw .van-popup {
  overflow: visible;
  border-radius: var(--van-dialog-border-radius);
}
.draw .van-action-bar {
  border-radius: var(--van-dialog-border-radius);
}
</style>